// extracted by mini-css-extract-plugin
export default {"badge":"AppBadge_badge__Yb-i+","active":"AppBadge_active__ERmmm","disabled":"AppBadge_disabled__QSNC4"};